module.exports = __webpack_public_path__ + "img/vertical_7_4_8003.05226b40.png";